"use client";
import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { Link } from "@nxt-costco-com/forge-components";
import { useProductTileData } from "../../../../../../../hooks/useProductTileData/index.js";
import { redColorTextStyles, blueColorTextStyles, linkStyles } from "./styles.js";
const ProductDeliveryBadge = () => {
  const { normalizedData, translationsConfig } = useProductTileData();
  const {
    productDeliveryBadgeData,
    productInfoData,
    isFsaEligible,
    isChdiEligible
  } = normalizedData;
  const { linkUrl } = productDeliveryBadgeData || {};
  const { groceryBadgeControls } = translationsConfig || {};
  const { firstBadge, secondBadge } = groceryBadgeControls || {};
  const COMPONENT_NAME = "ProductDeliveryBadge";
  if (!linkUrl) return null;
  const firstBadgeTextStyles = (firstBadge == null ? void 0 : firstBadge.color) === "Red" ? redColorTextStyles : blueColorTextStyles;
  const secondBadgeTextStyles = (secondBadge == null ? void 0 : secondBadge.color) === "Blue" ? blueColorTextStyles : redColorTextStyles;
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
    Link,
    {
      dataPrivate: Boolean(isFsaEligible || isChdiEligible),
      href: linkUrl,
      sx: linkStyles,
      uniqueId: `${COMPONENT_NAME}_${productInfoData.partNumber}`,
      children: [
        firstBadge && /* @__PURE__ */ jsx(Box, { component: "span", sx: firstBadgeTextStyles, children: (firstBadge == null ? void 0 : firstBadge.text) || "" }),
        secondBadge && /* @__PURE__ */ jsx(Box, { component: "span", sx: secondBadgeTextStyles, children: (secondBadge == null ? void 0 : secondBadge.text) || "" })
      ]
    }
  ) });
};
export {
  ProductDeliveryBadge
};
